<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Mutton Bustin' Championship Payment</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div class="headline text-xs-center mb-4">{{ this.buster.year }} RENO RODEO MUTTON BUSTIN' CHAMPIONSHIP PAYMENT</div>

          <div class="headline text-xs-center mt-4">
            Please enter payment for {{ this.buster.name }}.
          </div>

          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6>
                  <strong>Amount Due </strong>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.cardNumber"
                    label="Card #"
                    mask="credit-card"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.cardName"
                    label="Card Name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="editedItem.cardExpire"
                    label="Expire Date"
                    mask="##/##"
                  ></v-text-field>
                </v-flex>
                <v-flex xs5></v-flex>
                <v-flex xs3>
                  <v-text-field
                    v-model="editedItem.cardCvv"
                    label="CVV"
                    mask="####"
                  ></v-text-field>
                </v-flex>
                <v-flex xs8></v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="editedItem.amount"
                    label="Amount"
                    prefix="$"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.notes"
                    label="Notes"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-checkbox
                    v-model="editedItem.emailReceipt"
                    label="Email Receipt"
                  ></v-checkbox>

                </v-flex>
                <v-flex xs12 sm9>
                  <v-text-field
                    v-model="editedItem.emailPay"
                    label="Email Address"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="save">Save</v-btn>
            </v-card-actions>
          </v-form>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  data () {
    return {
      valid: true,
      currentYear: 0,
      checkbox: false,
      saved: false,
      buster: {},
      editedItem: {},
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.getBuster()
  },

  methods: {
    async getBuster () {
      const hash = new URL(location.href).searchParams.get('key')

      try {
        const response = await Api().get('get_bustinc_hash/' + hash)
        this.buster = response.data

        this.editedItem.id = this.buster.id
        this.editedItem.year = this.buster.year
        this.editedItem.name = this.buster.name
        this.editedItem.paid = 'Paid'
        this.editedItem.amount = 50.00
        console.log(this.buster)
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async save () {
      try {
        if (this.$refs.form.validate()) {
          const response = await Api().post('extern_mbc_payment', this.editedItem)
          console.log(response.data)

          this.saved = true
          this.snackbar.message = 'Congratulation, your payment has been submitted!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mbChampionship/Externalpayment.vue